import React from 'react';
import { Chart } from 'react-google-charts';
import { CollectionFinancialItem } from '@/DTOS/Report/GanttFinancial/CollectionFinancialItem';

interface ChartCollectionProps {
  contracts: CollectionFinancialItem[];
  selectedMonth: Date;
}

const ChartCollection: React.FC<ChartCollectionProps> = ({
  contracts,
  selectedMonth,
}) => {
  const addDays = (date: Date, days: number): Date => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  // Use selectedMonth to calculate first and last day of the month
  const firstDayOfMonth = new Date(
    selectedMonth.getFullYear(),
    selectedMonth.getMonth(),
    1
  );
  const lastDayOfMonth = new Date(
    selectedMonth.getFullYear(),
    selectedMonth.getMonth() + 1,
    0
  );

  const sortedContracts = contracts.slice().sort((a, b) => {
    const identifierComparison = a.identifier.localeCompare(b.identifier);
    if (identifierComparison !== 0) return identifierComparison;
    return parseInt(a.number) - parseInt(b.number);
  });

  const data = [
    [
      { type: 'string', label: 'Contract ID' },
      { type: 'string', label: 'Interval Description' },
      { type: 'date', label: 'Start Date' },
      { type: 'date', label: 'End Date' },
    ],
    ...sortedContracts.flatMap((contract) => {
      return contract.intervals
        .filter((interval) => {
          const startDate = new Date(interval.date);
          const endDate = addDays(startDate, 1);
          return startDate >= firstDayOfMonth && endDate <= lastDayOfMonth;
        })
        ?.map((interval) => {
          const startDate = new Date(interval.date);
          const endDate = addDays(startDate, 1);

          return [
            `${contract.identifier} ${contract.number}`,
            `${interval.price}`,
            startDate,
            endDate,
          ];
        });
    }),
  ];

  const options = {
    timeline: {
      showRowLabels: true,
      avoidOverlappingGridLines: false,
      barLabelStyle: { fontSize: 12 },
      colorByRowLabel: true,
    },
    colors: ['#00BFFF'],
    hAxis: {
      format: 'dd MMM',
      minValue: firstDayOfMonth,
      maxValue: lastDayOfMonth,
    },
    height: 300,
  };

  return (
    <Chart
      chartType='Timeline'
      width='100%'
      height='300px'
      data={data}
      options={options}
    />
  );
};

export default ChartCollection;
